import { useGetCoursesQuery } from '@services/courses'
import { PER_PAGE } from '@const/pagination'
import { createInitFilter } from '@utils/filters'
import { SortStates } from '@templates/ListPageLayout/Filters/Sorter'
import useItemsFilters, { FilterState } from './useItemsFilters'
import useMe from './useMe'

type Params = {
  withoutFiltersByUser?: boolean
  initFilters?: FilterState
  forcedFilters?: FilterState
  pagination?: boolean
  limit?: number
  skip?: boolean
  initOrder?: { order: Record<string, SortStates> }
  forListener?: boolean
}

const useCourses = (params?: Params) => {
  const {
    initFilters = {},
    forcedFilters,
    pagination = true,
    limit = PER_PAGE,
    skip,
    initOrder,
  } = params || {}
  const { id, isAdmin } = useMe()

  const { filters: baseFilters, setFilters, setPage, setOrder } = useItemsFilters(
    {
      ...initFilters,
      ...(isAdmin ? {} : createInitFilter('published', true)),
      // Note: type filter for employees removed - backend CourseFilterExtension
      // handles filtering to show both mini courses and internal free courses
    },
    pagination,
    limit,
    initOrder
  )

  const filters = forcedFilters ? { ...baseFilters, ...forcedFilters } : baseFilters

  const state = useGetCoursesQuery(filters, {
    skip: skip || !id,
    refetchOnMountOrArgChange: false,
    refetchOnFocus: false,
    refetchOnReconnect: false,
  })

  return {
    ...state,
    setPage,
    setFilters,
    setOrder,
  }
}

export default useCourses
